import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { DriversPage } from "@/features/drivers/pages/drivers-page";
import { driverFilterSchema } from "@/features/drivers/schemas/driver-filter-schema";

export const Route = createFileRoute("/_authenticated/fleet/drivers/")({
	head: () => pageTitle("Drivers"),
	component: DriversPage,
	validateSearch: zodValidator(driverFilterSchema),
});
